import { Outlet } from 'react-router-dom';

export default function SubAdminManagementLayout() {
    return (
        <Outlet />
    );
}
